// Brand logo for TERRE ET MER CONCIERGERIE, Concept C
// Stylized wave (3 lines: terre, mer, sable) + serif wordmark + sans-serif tagline
// Variants: dark (for light backgrounds) and light (for dark backgrounds)
//
// Use:
//   <Logo />                        light background
//   <Logo variant="light" />        dark background
//   <Logo size="sm" />              compact (favicon-style mark only)

const Logo = ({ variant = "dark", className = "h-10 w-auto", size = "full" }) => {
  const ink = variant === "dark" ? "#0B1A26" : "#FFFFFF";
  const accent = "#E08F5C";
  const subtle = variant === "dark" ? "#0B1A26" : "#FFFFFF";

  if (size === "mark") {
    // Just the wave mark (for favicon, app icons, social avatars)
    return (
      <svg viewBox="0 0 60 60" className={className} role="img" aria-label="Terre et Mer Conciergerie">
        <g transform="translate(5, 18)">
          <line x1="0" y1="0" x2="50" y2="0" stroke={ink} strokeWidth="2.5" strokeLinecap="round" />
          <path d="M 0 12 Q 12 4, 25 12 T 50 12" fill="none" stroke={accent} strokeWidth="3" strokeLinecap="round" />
          <path d="M 0 24 Q 12 18, 25 24 T 50 24" fill="none" stroke={ink} strokeWidth="2" strokeLinecap="round" opacity="0.6" />
        </g>
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 380 100" className={className} role="img" aria-label="Terre et Mer Conciergerie">
      {/* Stylized wave mark, thicker for better visibility */}
      <g transform="translate(20, 28)">
        <line x1="0" y1="0" x2="52" y2="0" stroke={ink} strokeWidth="2.4" strokeLinecap="round" />
        <path d="M 0 16 Q 13 7, 26 16 T 52 16" fill="none" stroke={accent} strokeWidth="3" strokeLinecap="round" />
        <path d="M 0 32 Q 13 25, 26 32 T 52 32" fill="none" stroke={subtle} strokeWidth="1.8" strokeLinecap="round" opacity="0.65" />
      </g>
      {/* Wordmark, bolder weight (600) for stronger presence */}
      <text x="100" y="50" fontFamily="Fraunces, Georgia, serif" fontWeight="600" fontSize="30" fill={ink} letterSpacing="1.5">TERRE</text>
      <text x="208" y="50" fontFamily="Fraunces, Georgia, serif" fontWeight="500" fontStyle="italic" fontSize="30" fill={accent}>et</text>
      <text x="248" y="50" fontFamily="Fraunces, Georgia, serif" fontWeight="600" fontSize="30" fill={ink} letterSpacing="1.5">MER</text>
      <text x="100" y="76" fontFamily="Outfit, sans-serif" fontWeight="600" fontSize="10" fill={ink} opacity="0.7" letterSpacing="4.5">C O N C I E R G E R I E</text>
    </svg>
  );
};

export default Logo;
